import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchAnalyticsScript } from 'api/googleAnalyticsApis';
import { redirectKey } from 'constants/config';

const SCRIPT_KEY = 'analyticsScripts';

export const useAnalyticsScript = () => {
  const [scripts, setScripts] = useState({ header: [], footer: [] });
  const location = useLocation();
  const [domain, setDomain] = useState('');

  useEffect(() => {
    const b = window.location.href;
    const envSuffix = new URL(redirectKey.replace('*.', '')).hostname;
    const urlHost = new URL(b).hostname;
    const subdomain = urlHost.replace(envSuffix, '');
    const result = subdomain?.split('.')[0];
    if (result) {
      setDomain(result);
    }
  }, []);

  useEffect(() => {
    const loadScript = async () => {
      const cached = localStorage.getItem(SCRIPT_KEY);
      if (cached) {
        setScripts(JSON.parse(cached));
        return;
      }

      const res = await fetchAnalyticsScript({ domain });
      const header = res?.data?.header || [];
      const footer = res?.data?.footer || [];
      const final = { header, footer };

      localStorage.setItem(SCRIPT_KEY, JSON.stringify(final));
      setScripts(final);
    };

    domain && loadScript();
  }, [domain]);

  // // Track route changes if gtag exists
  // useEffect(() => {
  //   if (window.gtag) {
  //     window.gtag('config', process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID, {
  //       page_path: location.pathname + location.search,
  //     });
  //   }
  // }, [location]);

  return { scripts, domain };
};
